/* Footer.jsx */
import React from "react";
import "./footer.css";
import logoImage from "./gourmet_logo_white.webp";
import { FacebookIcon, InstagramIcon, LinkedInIcon } from "./SocialIcons";

const menuLinks = [
  { label: "Anuncios", href: "/trabajos" },
  { label: "Empresas", href: "/empresas" },
  { label: "Nosotros", href: "/nosotros" },
  { label: "Preguntas Frecuentes", href: "/nosotros#faq" },
];

const companyLinks = [
  { label: "Registro", href: "/empresas/crear" },
  { label: "Acceso", href: "/empresas/entrar" },
  { label: "FAQ", href: "/nosotros#faq" },
];

const workerLinks = [
  { label: "Registro", href: "/profesionales/crear" },
  { label: "Acceso", href: "/profesionales/entrar" },
  { label: "FAQ", href: "/nosotros#faq" },
];

const contactItems = [
  "+569 7525 1224",
  "hola@gourmetjobs.cl",
  "Apoquindo 6410 – Oficina 605",
  "Las Condes, Santiago, Chile",
];

const socialMedia = [
  { icon: <FacebookIcon />, href: "https://www.facebook.com/gourmetjobschile?locale=es_LA" },
  { icon: <InstagramIcon />, href: "https://instagram.com/gourmetjobs" },
  { icon: <LinkedInIcon />, href: "https://linkedin.com/company/gourmet-jobs" },
];

const Footer = () => (
  <footer className="footer-container">
    <div className="footer-container__top">
      <div className="footer-container__logo-column">
        <img
          src={logoImage}
          alt="GourmetJobs"
          className="footer-container__logo"
        />
      </div>
      <div className="footer-container__columns">
        <div className="footer-container__links-wrapper">
          <div className="footer-container__links-column">
            <h4 className="footer-container__col-title">Menu</h4>
            <ul className="footer-container__link-list">
              {menuLinks.map((link) => (
                <li key={link.label} className="footer-container__link-item">
                  <a href={link.href}>{link.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-container__links-column">
            <h4 className="footer-container__col-title">Empresas</h4>
            <ul className="footer-container__link-list">
              {companyLinks.map((link) => (
                <li key={link.label} className="footer-container__link-item">
                  <a href={link.href}>{link.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-container__links-column">
            <h4 className="footer-container__col-title">Trabajadores</h4>
            <ul className="footer-container__link-list">
              {workerLinks.map((link) => (
                <li key={link.label} className="footer-container__link-item">
                  <a href={link.href}>{link.label}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="footer-container__contact-column">
          <h4 className="footer-container__col-title">Contacto</h4>
          {contactItems.map((text, i) => (
            <p key={i} className="footer-container__contact-item">
              {text}
            </p>
          ))}
        </div>
      </div>
    </div>

    <div className="footer-container__bottom">
      <hr className="footer-container__divider" />
      <div className="footer-container__bottom-content">
        <p className="footer-container__copyright">
          &copy; {new Date().getFullYear()} GourmetJobs – Todos los derechos
          reservados.
        </p>
        <div className="footer-container__social-icons">
          {socialMedia.map(({ icon, href }, index) => (
            <a key={index} href={href} target="_blank" rel="noopener noreferrer">
              {icon}
            </a>
          ))}
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;